<template>
    <div id="main">
        <section id="">
            <div :class="['container', '']">
                <div class="row">
                    <div :class="['col-lg-4', 'col-md-2', 'col-2']">
                        <div class="alert alert-info mt-0 mb-1" role="alert">
                            <p style="text-align:justify; font-size:14px;" class="mb-0">
                                Imprime y completa el <a href="javascript:void(0);" @click="downloadItem(path_file_download, file_select)"><b>Formato de solicitud de acceso a la información pública</b></a> con tus datos personales y el detalle de la información que solicitas de forma concreta y precisa.
                            </p>
                        </div>

                        <div class="">
                            <PdfThumbnail :fileUrl="url_prev" :updateFile="url_prev" style="border:2px solid #dee2e6; border-radius:5px;" :target="'_blank'" :width="320"></PdfThumbnail>
                        </div>
                    </div>

                    <div :class="['col-lg-8', 'col-md-8', 'col-8']">
                        <form-wizard ref="formwizard" @onCompleteNext="onCompleteNext" @onNextStep="nextStep" @onPreviousStep="previousStep" @onResetAll="resetAll" style="">
                            <tab-content title="Ciudadano" icon="fa-user" :selected="true">
                                <div :class="['row']">
                                    <div :class="['col-md-3']">
                                        <div class="form-group">
                                            <label for="tipo_persona" :class="['label_required']">Persona</label>
                                            <select id="tipo_persona" v-model="formData.tipo_persona" @change="cambiarTipoDocumento" ref="tipo_persona" :class="hasError('tipo_persona') ? 'is-invalid' : ''" class="form-control" >
                                                <option v-for="(val, key) in tipo_persona" :key="key" :data_longitud="val.longitud" :data_tipodoc="val.tipo_documento" :value="val.valor">{{val.descripcion}}</option>
                                            </select>
                                            <div v-if="hasError('tipo_persona')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.tipo_persona.required">Por favor el tipo de persona.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div :class="['col-md-3']">
                                        <div class="form-group">
                                            <label for="nro_documento" :class="['label_required']">{{(formData.tipo_persona=='1')?'DNI':'RUC'}}</label>
                                            <input type="text" class="form-control" @keypress="isNumber($event)" :class="hasError('nro_documento') ? 'is-invalid' : ''" :placeholder="'Ingrese su '+((formData.tipo_persona=='1')?'DNI':'RUC')" :maxlength="longitud_documento" v-model="formData.nro_documento">
                                            <div v-if="hasError('nro_documento')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.nro_documento.required">Ingrese el Nro de doc.</div>
                                                <div class="error" v-if="!$v.formData.nro_documento.numeric">Ingrese solo numeros.</div>
                                                <div class="error" v-if="!$v.formData.nro_documento.minLength.min">Ingrese {{longitud_documento}} digitos</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div :class="['col-md-6']">
                                        <div class="form-group">
                                            <label for="firmante" :class="['label_required']">Firmante</label>
                                            <input v-model="formData.firmante" type="text" class="form-control" :class="hasError('firmante') ? 'is-invalid' : ''" placeholder="Escriba el nombre completo del firmante">
                                            <div v-if="hasError('firmante')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.firmante.required">Por favor ingrese el nombre del firmante.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                
                                <div :style="{display:(formData.tipo_persona=='2')?'block':'none'}" :class="['row']">
                                    <div :class="['col-md-12']">
                                        <div class="form-group">
                                            <label for="empresa" :class="['label_required']">Empresa</label>
                                            <input type="text" class="form-control" :class="hasError('empresa') ? 'is-invalid' : ''" :placeholder="'Ingrese el nombre de su empresa'" v-model="formData.empresa">
                                            <div v-if="hasError('empresa')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.empresa.required">Por favor ingrese el Nombre de la empresa</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!---->

                                <div :class="['row']">
                                    <div :class="['col-md-12']">
                                        <div class="form-group">
                                            <label for="cargo">Cargo</label>
                                            <input type="text" class="form-control" :class="hasError('cargo') ? 'is-invalid' : ''" placeholder="Escriba aquí su cargo o dejelo en blanco" v-model="formData.cargo">
                                            <div v-if="hasError('cargo')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.fullName.required">Por favor ingrese el nombre del firmante.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div :class="['row']">
                                    <div :class="['col-md-6']">
                                        <div class="form-group">
                                            <label for="email" :class="['label_required']">Correo</label>
                                            <input v-model="formData.email" type="email" class="form-control" :class="hasError('email') ? 'is-invalid' : ''" placeholder="Escriba aquí su correo electronico">
                                            <div v-if="hasError('email')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.email.required">Por favor ingrese su correo electronico.</div>
                                                <div class="error" v-if="!$v.formData.email.email">Formato de correo incorrecto</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div :class="['col-md-6']">
                                        <div class="form-group">
                                            <label for="celular" :class="['']">Nro de Celular</label>
                                            <input v-model="formData.celular" @keypress="isNumber($event)" type="text" class="form-control" :class="hasError('celular') ? 'is-invalid' : ''" placeholder="Escriba aquí su Nro de Celular">
                                            <div v-if="hasError('celular')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.celular.required">Por favor ingrese su numero de celular.</div>
                                                <div class="error" v-if="!$v.formData.celular.numeric">Ingrese solo numeros.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <tab-content title="Documento" icon="fa-file-text-o"> 
                                <div :class="['row']">
                                    <div :class="['col-md-6']">
                                        <div class="form-group">
                                            <label for="tipo_documento_solicitud" :class="['label_required']">Tipo Documento</label>
                                            <select id="tipo_documento_solicitud" :class="hasError('tipo_documento_solicitud') ? 'is-invalid' : ''" class="form-control" v-model="formData.tipo_documento_solicitud">
                                                <option value="">[SELECCIONE]</option>
                                                <option v-for="(val , key) in tipo_documentos" :key="key" :value="val.id">{{val.nombre}}</option>
                                            </select>
                                            <div v-if="hasError('tipo_documento_solicitud')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.tipo_documento_solicitud.required">Por favor seleccione el tipo de documento.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div :class="['col-md-3']">
                                        <div class="form-group">
                                            <label for="numero_documento_solicitud" :class="['label_required']">Numero</label>
                                            <input type="text" class="form-control" :class="hasError('numero_documento_solicitud') ? 'is-invalid' : ''" placeholder="Ej. 001" v-model="formData.numero_documento_solicitud">
                                            <div v-if="hasError('numero_documento_solicitud')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.numero_documento_solicitud.required">Por favor ingrese el numero.</div>
                                                <div class="error" v-if="!$v.formData.numero_documento_solicitud.numeric">Solo numeros.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div :class="['col-md-3']">
                                        <div class="form-group">
                                            <label for="sigla_documento_solicitud" :class="['label_required']">Sigla</label>
                                            <input type="text" class="form-control" :class="hasError('sigla_documento_solicitud') ? 'is-invalid' : ''" placeholder="Ej. F-001" v-model="formData.sigla_documento_solicitud">
                                            <div v-if="hasError('sigla_documento_solicitud')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.sigla_documento_solicitud.required">Por favor ingrese la siga.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div :class="['row']">
                                    <div :class="['col-md-6']">
                                        <div class="form-group">
                                            <label for="archivo_documento_solicitado" :class="['label_required']">Documento PDF</label>
                                            <div class="custom-file">
                                                <input id="archivo" @change="CapturarNombreFile" type="file" ref="file" accept="application/pdf" class="custom-file-input required" :class="hasError('archivo_documento_solicitado') ? 'is-invalid' : ''">
                                                <input type="hidden" v-model="formData.archivo_documento_solicitado" />
                                                <label id="archivoLabel" class="custom-file-label">{{prev_file_upload}}</label>
                                            </div>
                                            <div v-if="hasError('archivo_documento_solicitado')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.archivo_documento_solicitado">Por favor suba un archivo en formato PDF.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div :class="['col-md-6']">
                                        <div class="form-group">
                                            <label for="anexo_documento_solicitado">Adjuntar Anexos (Ojo: <span style="font-size:12px;"><i>En caso de tener anexos</i></span>)</label>
                                            <div class="custom-file">
                                                <input id="archivo" @change="CapturarNombreAnexo" type="file" ref="file_anexo" accept="application/pdf" class="custom-file-input required" :class="hasError('anexo_documento_solicitado') ? 'is-invalid' : ''">
                                                <input type="hidden" v-model="formData.anexo_documento_solicitado" />
                                                <label id="archivoLabel" class="custom-file-label">{{prev_file_upload_anexo}}</label>
                                            </div>
                                            <div v-if="hasError('anexo_documento_solicitado')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.anexo_documento_solicitado.required">Por favor suba un archivo en formato PDF.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div :class="['row']">
                                    <div :class="['col-md-12']">
                                        <div class="form-group">
                                            <label for="asunto" >Anexos Adjuntos</label>
                                            <table class="table table-striped">
                                                <tbody>
                                                    <tr v-for="(val, key) in formData.anexos_solicitud" :key="key">
                                                        <td>{{val.name}}</td>
                                                        <td>
                                                            <button type="button" class="btn btn-danger">
                                                                <i class="fa fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="formData.anexos_solicitud.length<1">
                                                        <td colspan="2" class="text-left text-info"><i>Sin anexos...</i></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div :class="['row']">
                                    <div :class="['col-md-12']">
                                        <div class="form-group">
                                            <label for="asunto" :class="['label_required']">Asunto</label>
                                            <textarea class="form-control" :class="hasError('asunto') ? 'is-invalid' : ''" placeholder="Escriba aquí su asunto" v-model="formData.asunto" ></textarea>
                                            <div v-if="hasError('asunto')" class="invalid-feedback">
                                                <div class="error" v-if="!$v.formData.asunto.required">Por favor ingrese el asunto.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <tab-content title="Finalización" icon="fa-check-circle-o">
                                <div :class="['row']">
                                    <div :class="['col-md-12']">
                                        <div class="form-group">
                                            <div class="panel-body">
                                                <div class="form-group">
                                                    <table width="100% text-info">
                                                        <tbody>
                                                            <tr class="shadow" style="border:1px solid #28A745;">
                                                                <td class="align-middle p-4 text-center bg-success" width="5%">
                                                                    <i class="fa fa-check fa-2x" style="color:white;"></i>
                                                                </td>
                                                                                
                                                                <td class="align-middle p-4" width="95%" style="font-size:12px;">
                                                                    <h4 class="mb-3">Estimado ciudadano :</h4>
                                                                    <p class="text-justify">
                                                                        Le informamos que el documento digital que usted enviará, será tramitado por la Oficina de Trámite Documentario
                                                                        dentro de la Institución <strong>(Con o sin firma digital)</strong>, su trámite será 
                                                                        respondido en el transcurso de los dias enviándose la respuesta a su correo electrónico, por favor revise su correo 
                                                                        para verificar los <strong>DATOS DE SU TRÁMITE.</strong><br><br>

                                                                        <div class="col-md-12 shadow p-4" style="border:1px solid #999999;" >
                                                                            <strong style="color:#444444;">NRO DE TRÁMITE : <span id="codigoBarra">{{respuesta.codigoBarra}}</span></strong>
                                                                            <br><br>
                                                                            FECHA: <span id="fechaTramite">{{respuesta.fechaTramite}}</span><br>
                                                                            TIPO DE DOCUMENTO: <span id="tipoDocumento">{{respuesta.tipoDocumento}}</span><br>
                                                                            CORREO: <span id="correoUsuario">{{respuesta.correoUsuario}}</span><br>
                                                                            ENVIADO A : <span id="enviadoA">{{respuesta.enviadoA}}</span><br>
                                                                        </div>

                                                                        <br>

                                                                        <p>Para realizar su seguimiento de su trámite puede ingresar al portal del Gobierno Regional de San Martín en el Segmento SERVICIOS AL CIUDADANO en "CONSULTE SU TRAMITE (SIGI)", ingrese ahora mismo desde aquí:</p>
                                                                        <a href="https://www.regionsanmartin.gob.pe/Servicios?url=consulta_tramite" target="_blank" class="btn btn-success btn-sm"><i class="fa fa-search"></i> Consulte su trámite (SIGI)</a>
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <!--
                            <div class="alert alert-primary" role="alert">
                                <p style="text-align:justify">
                                    En caso de tener dificultades para enviar su documento, por favor enviar su documento al correo electronico alternativo 
                                </p>
                                <h1 :class="['text_width']">drasam.mesavirtual@gmail.com</h1>
                            </div>
                            -->
                            <div class="alert alert-warning mt-0 mb-0" role="alert">
                                <p style="text-align:justify;" class="mb-0">
                                    Los campos con el <span style="color:red">(*)</span> son obligatorios
                                </p>
                            </div>
                        </form-wizard>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import PdfThumbnail from '@/components/PdfThumbnail.vue';
    import FormWizard from '../components/FormWizard.vue';
    import TabContent from '../components/TabContent.vue';
    import axios from 'axios';
    import ValidationHelper from '../components/ValidationHelper.vue';
    import { required, email, numeric, minLength  } from 'vuelidate/lib/validators';

    export default {
        name: 'MesaParteVirtual',
        components:{
            FormWizard,
            TabContent,
            PdfThumbnail,
        },
        mixins: [ValidationHelper],
        computed:{
            ...mapState(['loading','globales','empresa']),
            url_prev(){
                this.path_file_download = `${window.baseUrl}webserviceserver/fileCors?file=${this.file_select}&dir=formato_solicitud_informacion`;
                return this.path_file_download;
            },
        },
        mounted(){
            window.location.href = 'https://mesavirtual.regionsanmartin.gob.pe/#/inicio-sesion'; return;
            this.loadObjEmpresa();
            document.title = "Mesa de Partes Virtual ||"+(this.empresa.abreviatura);
            this.cargarTipoDocumentoGORESAM();
            this.cambiarTipoDocumento();
        },
        data(){
            return{
                tipo_persona:[
                    {"descripcion":"NATURAL", tipo_documento:"DNI", "longitud":"8", valor:"1"},
                    {"descripcion":"JURIDICO", tipo_documento:"RUC", "longitud":"11", valor:"2"},
                ],
                tipo_documentos:[
                    /*
                    {descripcion:"Oficio", value:"4"},
                    {descripcion:"Oficio Multiple", value:"5"},
                    {descripcion:"Oficio circular", value:"6"},
                    {descripcion:"Carta", value:"7"},
                    {descripcion:"Carta multiple", value:"8"},
                    {descripcion:"Carta circular", value:"9"},
                    {descripcion:"Solicitud", value:"15"},
                    {descripcion:"Queja", value:"64"},
                    */
                ],
                oficina_tramite:"3565",
                formData:{
                    tipo_persona:"1",
                    nro_documento:null,
                    empresa:"",
                    firmante:"",
                    cargo:"",
                    email: null,
                    celular:null,

                    tipo_documento_solicitud: '',
                    numero_documento_solicitud: null,
                    sigla_documento_solicitud: null,
                    archivo_documento_solicitado:null,
                    anexo_documento_solicitado:null,
                    anexos_solicitud:[],
                    asunto:"",
                    destino_mesa_virtual:"",
                },
                validationRules:[
                    {
                        tipo_persona: {required},
                        nro_documento: {required, numeric, minLength: minLength(8)},
                        empresa:{required},
                        firmante: {required},
                        email: {required, email},
                        /*celular: {required, numeric},*/
                    },
                    {
                        tipo_documento_solicitud:{required},
                        numero_documento_solicitud:{required},
                        sigla_documento_solicitud:{required},
                        archivo_documento_solicitado:{required},
                        asunto:{required},
                        //destino_mesa_virtual:{required},
                    },
                ],
                longitud_documento:8,
                tipo_documento_solicitado:"",
                tipo_documento_solicitante:"DNI",
                prev_file_upload:"No seleccionó ningún archivo",
                prev_file_upload_anexo:"Seleccione sus anexos PDF",
                respuesta:{
                    fechaTramite:"",
                    tipoDocumento:"",
                    correoUsuario:"",
                    enviadoA:"",
                    codigoBarra:"",
                },
                file_select:"formato_acceso_inf_publico.pdf",
                path_file_select:"",
                path_file_download:"",
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            onComplete(){
                //console.log("Submitting Form ! Rock On");
                this.$refs.formwizard.changeStatus();
            },
            onCompleteNext(){
                var selfs = this;

                if(!this.$refs.file.files[0]){
                    this.formData.anexo_documento_solicitado = null;
                    return;
                }

                let  ente_goresam = "";
                let firma_goresam = "";
                
                if(this.formData.tipo_persona=="1"){
                    ente_goresam = "PERSONA NATURAL";
                    firma_goresam = this.formData.firmante.toUpperCase();
                }else if(this.formData.tipo_persona=="2"){
                    ente_goresam = this.formData.firmante.toUpperCase();
                    firma_goresam = this.formData.empresa.toUpperCase();
                }

                var formPost = new FormData();
                
                formPost.append('tipo_ente', this.formData.tipo_persona);               //PARAMETRO PARA GORESAM
                formPost.append('cargo', this.formData.cargo);                          //PARAMETRO PARA GORESAM
                formPost.append('ente', ente_goresam);                                  //PARAMETRO PARA GORESAM
                formPost.append('firma', firma_goresam);                                //PARAMETRO PARA GORESAM
                formPost.append('correo', this.formData.email);                         //PARAMETRO PARA GORESAM
                formPost.append('tipo_documento', this.formData.tipo_documento_solicitud);//PARAMETRO PARA GORESAM
                formPost.append('numero', this.formData.numero_documento_solicitud);    //PARAMETRO PARA GORESAM
                formPost.append('sigla', this.formData.sigla_documento_solicitud);      //PARAMETRO PARA GORESAM
                formPost.append('asunto', this.formData.asunto);                        //PARAMETRO PARA GORESAM
                formPost.append('dni', this.formData.nro_documento);                    //PARAMETRO PARA GORESAM
                formPost.append('oficina_tramite', this.oficina_tramite);               //PARAMETRO PARA GORESAM
                console.log(this.$refs.file.files[0]);
                formPost.append('archivos', this.$refs.file.files[0]);                  //PARAMETRO PARA GORESAM
                this.formData.anexos_solicitud.map((v, k)=>{
                    formPost.append('anexos[]', v);                                     //PARAMETRO PARA GORESAM
                });
                //console.log(formPost);return;
                this.setLoading(true);
                let url_api_goresam = "https://dgst.regionsanmartin.gob.pe/tramite/api/v1/documento";
                //let url_api_goresam = "https://prod.regionsanmartin.gob.pe/tramite/api/v1/documento";
                //let url_api_goresam = "https://dev.regionsanmartin.gob.pe/tramite/api/v1/documento";
                //let url_api_goresam = "webserviceserver/guardar_solicitud_mesavirtual";
                //this.$http.post(url_api_goresam, formPost,{ header:{'Content-Type' : 'multipart/form-data'}}).then((res)=>{
                axios.post(url_api_goresam, formPost,{ header:{'Content-Type' : 'multipart/form-data'}}).then((res)=>{
                    if(!res.data.dedeId){
                        selfs.alertError("Hubo problemas al enviar la solicitud, intente mas tarde", function(){
							
						});
                    }else if(!res.data.codigoBarra || res.data.codigoBarra==""){
                        selfs.alertError("No se pudo obtener el numero de expediente, intente mas tarde.", function(){
							
						});
                    }else{
                        this.respuesta.codigoBarra      = res.data.codigoBarra
                        this.respuesta.fechaTramite     = res.data.tramite[0].fechaHora;
                        this.respuesta.tipoDocumento    = res.data.tipoDocumento.nombre;
                        this.respuesta.correoUsuario    = res.data.correo;
                        this.respuesta.enviadoA         = res.data.tramite[0].oficinaOrigenNom;

                        selfs.$refs.formwizard.changeStatus();
                        selfs.$refs.formwizard.nextTab();
                    }
                }).catch(function(error){
                    if (error.response) {
                        selfs.alertError(error.response.data, function(){
							location.reload();
						});
                        //console.log(error.response.data);
                        //console.log(error.response.status);
                        //console.log(error.response.headers);
                    } else if (error.request) {
                        console.log(error.request);
                    } else {
                        //console.log('Error', error.message);
                    }
                    console.log(error.config);
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
            reset(){
                for(let field in this.formData){
                    this.formData[field] = null;
                }
            },
            resetAll(){
                location.reload();
            },
            nextStep(){
                let sigla_goresam = "";
                this.formData.firmante.split(" ").map(function(value, key){
                    sigla_goresam += value.charAt(0);
                });
                this.formData.sigla_documento_solicitud = sigla_goresam.toUpperCase() + "-" + new Date().getFullYear();
            },
            previousStep(){
                //alert("On Previous Step");
                this.formData.archivo_documento_solicitado = null;
                this.prev_file_upload = "No seleccionó ningún archivo";
                console.log(this.prev_file_upload);
                console.log("On Previous Step");
            },
            CapturarNombreFile(){
                this.prev_file_upload = this.$refs.file.files[0].name;
                this.formData.archivo_documento_solicitado = this.prev_file_upload;
            },
            CapturarNombreAnexo(){
                this.prev_file_upload_anexo         = "Añadir mas anexos PDF";
                this.formData.anexos_solicitud.push(this.$refs.file_anexo.files[0]);
            },
            cambiarTipoDocumento(){
                if(this.formData.tipo_persona=='1'){
                    this.formData.empresa = "-";
                    this.longitud_documento = 8;
                    this.tipo_documento_solicitante = "DNI";
                }else{
                    this.formData.empresa = "";
                    this.longitud_documento = 11;
                    this.tipo_documento_solicitante = "RUC";
                }
            },
            cargarTipoDocumentoGORESAM(){
                this.setLoading(true);
                //this.$http.get('webserviceserver/lista_documentos_goresam').then((res)=>{
                axios.get('https://dev.regionsanmartin.gob.pe/tramite/api/v1/tipo_documento/externos').then((res)=>{
                    this.tipo_documentos = res.data;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
            borrarAnexo(){
                
            },
        },
    }
</script>

<style>
    .step-footer{margin:0px !important;}
    .vue-step-wizard{padding: 10px 10px 10px 10px; width:100%; min-width: 500px;}
    section#services{
        padding: 5px 0;
    }
</style>